import * as React from 'react';

export function useEvents(menuRef: any, triggerRef: any, handlerTrigger: any) {
  React.useEffect(() => {
    if (menuRef.current) {
      (menuRef.current! as HTMLElement).querySelectorAll('[data-role="menu-item"]').forEach(e => e.addEventListener('click', handlerTrigger));
    }

    if (triggerRef.current !== null) {
      (triggerRef.current! as HTMLElement).addEventListener('click', handlerTrigger);
    }
    return () => {
      (triggerRef.current as HTMLElement | null)?.removeEventListener('click', handlerTrigger);
      (menuRef.current! as HTMLElement).querySelectorAll('[data-role="menu-item"]').forEach(e => e.removeEventListener('click', handlerTrigger));
    }
  }, [handlerTrigger]);
}